import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type PaidDriverListItem = ResultOf<
  typeof proDriverListQuery
>["proDrivers"]["data"][number];

export const proDriverListQuery = graphql(`
  query PaidDriverList(
    $page: Int
    $first: Int!
    $search: String
    $region: [Region!]
    $city: [String!]
    $licenseType: [ProDriverLicenseType!]
    $hasTowVehicle: Boolean
    $orderBy: [QueryProDriversOrderByRelationOrderByClause!]
    $radiusAround: RadiusAround
    $sortByRating: SortOrder
    $sortByMoves: SortOrder
    $sortByPushToken: SortOrder
    $excludeJobOpeningId: ID
    $archived: Boolean
  ) {
    proDrivers(
      first: $first
      page: $page
      search: $search
      orderBy: $orderBy
      region: $region
      radiusAround: $radiusAround
      city: $city
      licenseType: $licenseType
      hasTowVehicle: $hasTowVehicle
      sortByRating: $sortByRating
      sortByMoves: $sortByMoves
      sortByPushToken: $sortByPushToken
      excludeJobOpeningId: $excludeJobOpeningId
      archived: $archived
    ) {
      data {
        id
        created_at
        updated_at
        bio

        name
        email
        phone
        date_of_birth

        numberOfCompletedAssignments
        numberOfReviews
        rating
        hasPushToken

        basedIn {
          id
          name
          region
          state
          created_at
        }

        license_type
        has_tow_vehicle
        tow_vehicle_type
        tow_vehicle_year
        tow_capacity_kg
      }
      paginatorInfo {
        total
        lastPage
        currentPage
        count
        hasMorePages
        perPage
      }
    }
  }
`);
